export const COMPONENT_TYPE = Object.freeze({
    NESTED_SELECT: 'nested-select',
    SELECT: 'select',
    CATEGORY: 'category',
    RANGE_SLIDER: 'range-slider',
    RANGE_INPUT: 'range-input'
});

export const selectionType = {
    RANGE: 'range',
    SINGLE: 'single',
    MULTIPLE: 'multiple'
};

export const APPLIED_COMPONENT_TYPE = Object.freeze({
    RANGE_INPUT: 'range-input',
    RANGE_SLIDER: 'range-slider',
    SELECT: 'select',
    NESTED_SELECT: 'nested_select'
});

export const ONE_ROW_HEIGHT = 89;
export const ZERO_ROW_HEIGHT = 0;
export const visualizationFilters = {
    VIEW_TYPE: 'view',
    SORT_TYPE: 'sort'
};
export const QUERY_PARAM_CONFIG = {
    [visualizationFilters.SORT_TYPE]: 'sorting'
};

export const TRACK_FILTER_TYPE = {
    CUSTOM_BOX: 'custom-box',
    CUSTOM_LIST: 'custom-list',
    CUSTOM_SLIDER: 'custom-slider',
    POPULAR_LIST: 'popular-list',
    POPULAR_GRID: 'popular-grid',
    SEARCH: 'search'
};

export const TRACK_CLOSE_CONFIRMATION_EVENTS = {
    CANCEL: 'cancel',
    CHANGE: 'change'
};

export const ATTR_NOT_TO_FORMAT = {
    year: true,
    m_year: true
};
export const FILTER_NO_ABUNDANCE = {};

export const ATTR_WITHOUT_SUFFIX = {
    year: true,
    m_year: true
};
export const ATTR_WITH_MAX_LIMIT = {
    year: true,
    m_year: true
};
export const SCROLL_DEBOUNCE_TIMER = 300;
export const RANGE_KEY_SEPARATOR = '-';
export const PLUS_SUFFIX = '+';
export const FILTER_DRAWER = {
    EXTERNAL_TRIGGER_THRESHOLD: 3,
    MAX_HEIGHT: 250,
    SCROLLBAR_THRESHOLD: 200,
    MIN_HEIGHT: 100,
    TAG_HEIGHT: 32,
    PADDING: 65,
    ALT_PADDING: 20,
    FIRST_WIDTH: 70,
    SECOND_WIDTH: 150,
    MAX_ROW_WIDTH: 170
};
export const POPULAR_GRID_COL = 3;
export const INSPECTED_FILTER_ATTR = 'inspected';
export const OLX_AUTOS_FILTER_ATTR = 'olxautos_listing';
export const VISUALIZATION_KEY = 'visualizationV2';
export const NESTED_FILTER_PARAM = 'nested-filters';

export const PREFIX_AUT_ID = 'ulLevel_';
export const MAX_ITEMS_SHOW = 5;

export const FACET_LABEL_TYPE = 'span';
export const FACET_OPTION_TYPE = 'div';

export const EXCLUDED_DISABLED_FILTER_CATEGORIES = ['1725', '1723'];

export const RE_FILTERS_SCREEN_SHOWN = 're_filters_screen_shown';

export const DATE_PUBLISHED = 'desc-creation';

export const QUICK_FILTERS = {
    MAKE: 'make',
    MODEL: 'model',
    MAKE_AND_MODEL: 'Make and Model'
};
